import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import * as styles from "./styles.scss";
import * as types from "./types";
import { Html } from "../../components";
import { tl } from "../../utils";

interface IProps {
  items?: any[];
}

const answerTypeRenders: any = {
  text: types.Text,
  checkbox: types.Checkbox,
  checkbox_img: types.CheckboxImg,
  file: types.File,
  radio: types.Radio,
  radio_img: types.CheckboxImg,
  any_one_text: types.Radio,
  any_one_img: types.CheckboxImg,
  any_text: types.Checkbox,
  any_img: types.CheckboxImg,
  record: types.Record,
  relation: types.Relation,
  sort: types.Sort,
  sort_img: types.Sort,
  statistic: types.Statistic,
  equally: types.Equally,
  fill: types.Fill,
  select: types.Select,
  image_text_relation: types.RelationTextImage,
};

const renderItem = (item: any, i: any) => {
  const Element = answerTypeRenders[item.type];
  return Element ? (
    <div className={styles.answer} key={i}>
      {!item.question || (
        <div className={styles.question}>
          <span className={styles.questionTitle}>
            {tl("Вопрос")} {item.question.questionNumber}.
          </span>
          <Html>{item.question.question}</Html>
        </div>
      )}
      <Element {...item} />
      <h4
        style={{ marginTop: 10 }}
        className={
          item.isAnswered ? (item.isRight === "right" ? "green" : "red") : null
        }
      >
        {item.isAnswered
          ? item.isRight === "right"
            ? tl("Принят!")
            : item.isRight === "wrong"
            ? tl("Не принят!")
            : ""
          : tl("Пропущен!")}
      </h4>
    </div>
  ) : null;
};

export const Answer = (props: IProps) => {
  return <div className={styles.answers}>{props.items.map(renderItem)}</div>
};
